<div class="tw-flex tw-gap-x-8 tw-h-full tw-max-h-[calc(100vh_-_230px)]">
  <!-- テーブル表示 -->
  <div class="tw-w-1/2 tw-h-full tw-min-w-[550px] tw-relative">
    <!-- 地図のロードが完了し地図コンポーネントから地図の描画範囲を受け取った後にテーブルを表示 -->
    @if (isMapLoaded && mapBounds !== undefined) {
      <app-device-info-map-list-table
        [deviceList]="deviceList"
        [mapBounds]="mapBounds"
        [selectedDevice]="selectedDevice"
        (deviceSelectionChange)="selectDevice($event)"
      ></app-device-info-map-list-table>
    }
  </div>

  <!-- 地図表示 -->
  <div class="tw-w-1/2 tw-h-full tw-min-w-[600px]">
    <app-device-info-map
      [deviceList]="deviceList"
      [selectedDevice]="selectedDevice"
      (mapLoaded)="onMapLoaded()"
      (mapMoveEnd)="onMapMoveEnd($event)"
      (markerChanged)="onMarkerChanged($event)"
    ></app-device-info-map>
  </div>
</div>
